import { VideoPlayer, VideoPlayerEvent } from '../../../video/client/video-player';
import { initVideoPlayer } from '../../../_common/client/nexus-interfaces/video';
import { trackEvent } from '@otto-ec/nexus-registry/pdp/tracking';

export class MainImageVideo {
    private static readonly VIDEO_PARENT_ID = 'js_pdp_main-image__video';

    private readonly assetKey: string;

    private readonly videoElement: HTMLElement;
    private readonly videoWrapperElement: HTMLElement;

    private videoPlayer?: VideoPlayer;

    constructor(assetKey: string, targetElement: HTMLElement) {
        this.assetKey = assetKey;

        this.videoElement = document.createElement('div');
        this.videoElement.classList.add('pdp_main-image__video');
        this.videoElement.id = MainImageVideo.VIDEO_PARENT_ID;

        this.videoWrapperElement = document.createElement('div');
        this.videoWrapperElement.classList.add('pdp_main-image__video-wrapper');
        this.videoWrapperElement.appendChild(this.videoElement);

        targetElement.appendChild(this.videoWrapperElement);
    }

    public pause() {
        this.videoPlayer?.pause();
    }

    public async init() {
        if (!this.videoPlayer) {
            this.videoElement.innerHTML = '';
            try {
                this.videoPlayer = await initVideoPlayer({
                    assetKey: this.assetKey,
                    parentId: MainImageVideo.VIDEO_PARENT_ID,
                    backgroundColor: 'transparent',
                    stage: { height: '100%' },
                    autoplay: false,
                    onAspectRatioChange: aspectRatio => {
                        const [width, height] = aspectRatio.split(':');
                        if (width && height) {
                            const relativeVideoHeight = (Number(height) / Number(width)) * 100;
                            this.videoWrapperElement.style.setProperty('--percentage-video-height', String(relativeVideoHeight));
                            this.videoWrapperElement.style.setProperty(
                                '--percentage-video-height-with-unit',
                                String(relativeVideoHeight) + '%'
                            );
                        }
                    },
                    onProgress10: event => this.trackPlayerEvent(event, 'progress_0.1'),
                    onProgress50: event => this.trackPlayerEvent(event, 'progress_0.5'),
                    onProgress90: event => this.trackPlayerEvent(event, 'progress_0.9'),
                    onQualityChange: event => this.trackPlayerEvent(event, 'changeQuality'),
                    onInitialVideoStart: event => this.trackPlayerEvent(event, 'start'),
                    onFullscreenChange: event => this.trackPlayerEvent(event, event.isFullscreen ? 'openFullscreen' : 'closeFullscreen'),
                    onChangeVideo: event => this.trackPlayerEvent(event, 'changeVideo'),
                });
            } catch (error: unknown) {
                this.videoElement.innerHTML = 'Es ist ein technischer Fehler aufgetreten. Bitte rufe das Video erneut auf.';
                trackEvent({ product_Video: [(error as Error)?.message] });
            }
        }
    }

    private trackPlayerEvent(event: VideoPlayerEvent, trackingEventName: string): void {
        trackEvent({
            product_Video: [trackingEventName],
            product_VideoCount: [String(event.videoCount)],
            product_VideoLength: [String(event.videoLength)],
            product_VideoPosition: [String(event.videoPosition)],
            product_VideoQuality: [String(event.videoQuality)],
        });
    }
}
